<script>
    import state from '../../state';
</script>

<style>
    .spotify {
        width: 380px;
        max-width: 100%;
        /* position: absolute;
        bottom: 0;
        left: 0;
        padding: 5px 15px 15px; */
        margin-top: auto;
        text-align: left;
    }

    .spotify .track {
        line-height: 14px;
        font-size: 12px;
        color: #bbb;
    }

    .spotify .track i {
        color: #1DB954;
    }

    .spotify .track a {
        color: inherit;
    }

    .spotify progress {
        width: 100%;
    }
</style>

<div class="spotify">
    <div class="track">
        <i class="fab fa-spotify"></i>
        <a href="{$state.track.link}" target="_blank" rel="noopener noreferrer">{$state.track.artist} - {$state.track.name}</a>
    </div>
    <progress max={$state.track.length} value={$state.track.progress_real}></progress>
</div>
